import React from "react";
import "./Cards.css";
import ReactPlayer from "react-player";

function Cardsvideo() {
  return (
    <div className="cards">
      <h1>OUR VIDEO DESIGN</h1>
      <h2>Watch our videos here or on our clients YouTube channels</h2>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <li className="cards__item">
              <div className="cards__item__link">
                <div className="cards__item__pic-wrap">
                  <div className="cards__item__img_v">
                    <div className="reel_card">
                      <>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=wqMJk0MJuhc&t=1s"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </>
                    </div>
                  </div>
                </div>
                <div className="cards__item__info">
                  <h5 className="cards__item__text">Roaming Smart Solutions</h5>
                </div>
              </div>
            </li>
            <li className="cards__item">
              <div className="cards__item__link">
                <div className="cards__item__pic-wrap">
                  <div className="cards__item__img_v">
                    <div className="reel_card">
                      <>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=HaE45Rh9Kqg"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </>
                    </div>
                  </div>
                </div>
                <div className="cards__item__info">
                  <h5 className="cards__item__text">App SW</h5>
                </div>
              </div>
            </li>
          </ul>
          <ul className="cards__items">
            <li className="cards__item">
              <div className="cards__item__link">
                <div className="cards__item__pic-wrap">
                  <div className="cards__item__img_v">
                    <div className="reel_card">
                      <>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=suAzZTa58SY&t=2s"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </>
                    </div>
                  </div>
                </div>
                <div className="cards__item__info">
                  <h5 className="cards__item__text">ELSYS Eastern EU</h5>
                </div>
              </div>
            </li>
            <li className="cards__item">
              <div className="cards__item__link">
                <div className="cards__item__pic-wrap">
                  <div className="cards__item__img_v">
                    <div className="reel_card">
                      <>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=mp9SmbrKLqo"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </>
                    </div>
                  </div>
                </div>
                <div className="cards__item__info">
                  <h5 className="cards__item__text">Roaming Solutions Group</h5>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cardsvideo;
